export const PWmatTrialDownload = [
  {
    docker:'PWmat(CPU)',
    install:'1.安装docker-ce(version>=18.06.0)<br/>2.下载并解压pwmat_cpu.tar.gz，得到pwmat_cpu.tar<br/>3.导入pwmat_cpu.tar,具体导入命令为:<br/>docker import pwmat_cpu.tar pwmat:cpu',
    system:'CentOS, Ubuntu, windows10 pro',
    download:'pwmat_cpu.tar.gz',
    downloadUrl:'https://pan.baidu.com/s/12P3C2Q1TZncPERFsH8THLg#list/path=%2F',
    updateTime:'20190113',
  },
  {
    docker:'PWmat(GPU)',
    install:'1.安装docker-ce(version>=18.06.0)<br/>2.安装nvidia-docker2<br/>3.下载并解压pwmat_gpu.tar.gz，得到pwmat_gpu.tar<br/>4.导入pwmat_gpu.tar,具体导入命令为:<br/>nvidia-docker import --change "ENV NVIDIA_VISIBLE_DEVICES=all"<br/>--change "ENV NVIDIA_DRIVER_CAPABILITIES=all" pwmat_gpu.tar pwmat:gpu',
    system:'CentOS, Ubuntu',
    download:'pwmat_gpu.tar.gz',
    downloadUrl:'https://pan.baidu.com/s/12P3C2Q1TZncPERFsH8THLg#list/path=%2F',
    updateTime:'20190113',
  },
]

export const PWmatFreeDownload = [
  {
    soft:'intel compiler',
    edition:'2016',
    install:'1.去intel官网下载intel编译器2016，并解压：$ tar -zxvf parallel_studio_xe_2016_update2.tgz<br/>2.进入解压后的目录：$ cd parallel_studio_xe_2016_update2<br/>3.下载2016.silent.cfg文件，并上传到当前目录，修改2016.silent.cfg文件的第15行可以指定安装位置，第33行指定许可证书的位置，需要注意的是必须为绝对路径）<br/>4.运行安装命令：$ sh install.sh --silent ./2016.silent.cfg<br/>',
    download:'2016.silent.cfg',
    downloadUrl:'https://pan.baidu.com/s/1KpUqYPxFekwC4YFBfOtuJQ',
    notice:'1.运行安装命令之前记得修改2016.silent.cfg的第15和33行的路径<br/>2.安装之后需要添加环境变量，具体命令为，其中xxx表示intel的安装路径，与2016.silent.cfg文件的15行相同：<br/>$ echo "source xxx/bin/compilervars.sh intel64" >> ~/.bashrc',
  },
  {
    soft:'cuda',
    edition:'10.1',
    install:'1.下载cuda安装包cuda_10.1.168_418.67_linux.run<br/>2.$ sh cuda_10.1.168_418.67_linux.run --toolkit --toolkitpath=/home/tianhongzhen/cuda-10.1 --samples --samplespath=/home/tianhongzhen/cuda-10.1 #开始安装<br/>#..一堆协议说明...<br/>Do you accpet the above EULA? (accept/decline/quit): accept #接受协议<br/>CUDA Installer<br/>- [X] Driver #选择是否安装显卡驱动，按回车键可以把[X]变成[]，从而取消驱动安装<br/>   [X] 418.67 #显卡驱动的版本<br/>[X] CUDA Toolkit 10.1<br/>[X]CUDA Samples 10.1<br/>[X] CUDA Demo Suite 10.1<br/>[X] CUDA Documentation 10.1<br/>Options #回车进入Options，进入之后设置Library install path (Blank for system default)为：/home/tianhongzhen/cuda-10.1<br/>Install #选择该项，按回车键进行安装'  ,
    download:'cuda-10.1',
    downloadUrl:'https://developer.nvidia.com/compute/cuda/10.1/Prod/local_installers/cuda_10.1.168_418.67_linux.run',
    notice:'1.安装完成之后需要添加环境变量，具体命令为：<br/>$ echo "export PATH=/home/tianhongzhen/cuda-10.1/bin:$PATH" >> ~/.bashrc<br/>$ echo "export LD_LIBRARY_PATH=/home/tianhongzhen/cuda-10.1/lib64:$LD_LIBRARY_PATH" >> ~/.bashrc<br/>$ echo "export CUDADIR=/home/tianhongzhen/cuda-10.1" >> ~/.bashrc<br/>2.特别注意路径替换，上述所有的/home/tianhongzhen/都是我自己账户的路径，大家在安装以及设置环境变量的时候一定要替换为自己的账户路径。',
  },
  {
    soft:'PWmat',
    edition:'2.0',
    install:'1.下载PWmat安装包，并解压:$ unzip cuda-10.1-free.zip<br/>Archive: cuda-10.1-free.zip<br/>inflating: install.free.run<br/>2.$ sh install.beta.run<br/>Verifying archive integrity... All good.<br/>Uncompressing install PWmat  100%<br/>>>> Please input the full path where to install PWmat<br/>>>> The default directory is [/home/xxx/PWMAT]方括号内为默认的安装目录<br/>>>> The PATH(Press Enter to accept the default):回车选择默认的目录，也可以自己手动输入<br/>>>> The directory /home/xxx/PWMAT/xxxxxxxx ... OK!<br/>>>> Do you wish to clean and update the .bashrc?[Y/y/N/n][default:N]y<br/>>>> FINISH INSTALLING PWmat IN DIRECTROY: /home/xxx/PWMAT/xxxxxxxx<br/>3.$ bash',
    download:'请与我们联系获取安装包',
    downloadUrl:'http://longxun2015.mikecrm.com/y72WBOU',
    notice:'1.安装PWmat之前一定要确保安装了正确版本的intel compiler和cuda<br>2.请与我们联系获取PWmat安装包，提供GPU的uuid给我们，我们把你的GPU的uuid添加到PWmat安装包之后，你才能使用，否则下载的安装包是无法使用的。',
  },
]

export const MSTATIONDownload = [
  {
    id:'0',
    CUDA:'11.6',
    OpenMPI:'oneAPI2022',
    LS3DFVersion:'Latest',
    installPackage:'LS3DF Latest CUDA11.6',
    downloadUrl:'LS3DF_package_20260525.tar.gz',
instruction:'',
updateTime:'20260525',
  }
]
export const MCLUSTERDownload = [
  {
    id:'0',
    CUDA:'11.6',
    OpenMPI:'oneAPI2022',
    LS3DFVersion:'Latest',
    installPackage:'LS3DF Latest CUDA11.6',
    downloadUrl:'LS3DF_package_20260525.tar.gz',
instruction:'',
updateTime:'20260525',
  }
]
